import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
  import { useParams ,useHistory,} from "react-router-dom";

  import { useDispatch } from 'react-redux';
  import { useSelector } from "react-redux";
  
import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import ProductMenuRightCard from "../AppCards/ProductMenuRightCard";
import CreateCourseCurriculum from "../../Create/CreateContent/CreateCourseCurriculum";
import ApproxContents from "./ApproxContents";
import { DiffIcon, Settings } from "lucide-react";
import SelectCourseInReduxPopUp from "../../Create/CreateContent/SelectCourseInReduxPopUp";
import AddThumbnailProduct from "./AddThumbnailProduct";
import AddDemoVideosProducts from "./AddDemoVideosProducts";
import ShowLabelsCards from "./ShowLabelsCards";
import DifficultyLevelLabels from "./DifficultyLevelLabels";
import LanguageLabels from "./LanguageLabels";
import TypeLabels from "./TypeLabels";
import StatusLabels from "./StatusLabels";
import ShowAdditionalInfoCards from "./ShowAdditionalInfoCards";
import WhatULearnProduct from "./WhatWillULearnProduct";
import TargetAudienceProduct from "./TargetAudienceProduct";
import PreRequisiteProduct from "./PreRequisiteProduct";
import HighlightsProduct from "./HighllightsProduct";
import SkillsProduct from "./SkillsProduct";
import FAQsProduct from "./FAQsProduct";
import FreeTrial from "./FreeTrial";
import SEOProduct from "./SEOProduct";
import AppearanceProduct from "./AppearanceProduct";
import SettingsProduct from "./SettingsProduct";
import StudentLimitProduct from "./StudentLimitProduct";
import ShowStartInfoCards from "./ShowStartInfoCards";
import CreatePricePlan from "../CreatePricePlan/CreatePricePlan";
import ExpiryAndPrivacy from "../CreatePricePlan/ExpiryAndPrivacy";
import MyCourses from "../MyCourses";

// npm i @loadable/component 

let lazyLoad =   <Loading/>;
  
const ProductTitle = loadable(() => import("./ProductTitle"), {
  fallback: lazyLoad  });


  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const CreateProduct = ({onClickSetOverviewState})=>{
      const {url}=useRouteMatch();
      
  const history = useHistory();
      const dispatch = useDispatch();
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [deviceWidth,setDeviceWidth] = useState(false);
           const bottomDivRef = useRef(null);
           
           const bottomDivBoxRef = useRef(null);
           const bodyWidthForMobile =useRef(null)
         
                  const [isVisible, setIsVisible] = useState(false);
                
                  const [divHeight, setDivHeight] = useState(0);
                           const [activeCardBasicInfo, setActiveCardBasicInfo] =useState(false);
                           const [activeCardLabels, setActiveCardLabels] =useState(false);
                           const [activeAdditionaInfo, setActiveAdditionaInfo] =useState(false);
                           const [activeCardFreeTrial, setActiveCardFreeTrial] =useState(false);
                           const [activeCardSEO, setActiveCardSEO] =useState(false);
                           const [activeCardAppearance, setActiveCardAppearance] =useState(false);
                           const [activeCardSettings, setActiveCardSettings] =useState(false);
                            const [colorThemeGrid, setColorThemeGrid] =useState(true);   
                            const [colorThemeList, setColorThemeList] =useState(false);   
                            const [selectCoursePopUp, setSelectCoursePopUp] =useState(false);   
                             const [activeCardOverview, setActiveCardOverview] =useState(false);
                                     const [activeCardScreens, setActiveCardScreens] =useState(false);
                                     const [activeCardElements, setActiveCardElements] =useState(false); 
                                       
                                     const [fixMenuAppRight, closeFixMenuAppRight] =useState(false);   
                                      const [openAppDesignPopUpInn,setopenAppDesignPopUpInn]  = useState(false);
                                    
                                     const rightFixClose =fixMenuAppRight?"-50%":"30px";
                                     const rightFixOpen =fixMenuAppRight?"30px":"-50%";
                                     const fixMenuAppRightHide={width:"70px",right:rightFixOpen,height:"80px"}
                                     const fixMenuAppRightShow={width:"70px",right:rightFixClose}
                                   
                                            const [designContent, openDesignContent] =useState(false);    
                             const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
const courseData = useSelector((state)=>state?.course?.course);

      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const user_email = useSelector((state)=>state?.user?.user?.user_email
);
const [activeStep, setActiveStep] = useState(0);
const [activeSubStepOne, setActiveSubStepOne] = useState(1);
const [currentAppCourses, setCurrentAppCourses] =useState(false)
const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
const [activeSubStepThree, setActiveSubStepThree] = useState(0);
const [activeSubStepFour, setActiveSubStepFour] = useState(0);
const [activeSubStepFive, setActiveSubStepFive] = useState(0);
const [productMenuRightCardPrice, setProductMenuRightCardPrice] = useState(false);

let TypeLink= courseData?.ID?courseData?.type=='course'?"course-name":
courseData?.type=='batch'?"batch-name":
courseData?.type=="testSeries"?"test-series-name":
courseData?.type=="homeTutor"?"home-tutor-offering-name":
courseData?.type=="bundle"?"bundle-name":
courseData?.type=="digitalProduct"?"digital-product-name":"":"course-name";

const steps = [1, 2, 3, 4, 5];
const subSteps = [1, 2, 3, 4, 5];
const subStepOneTotal= 5;
const subStepTwoTotal= 3;
const subStepThreeTotal= 4;
const subStepFourTotal= 8;
const subStepFiveTotal= 1;
;
const handleNext = () => {
  if (activeStep < steps.length - 1) {
    setActiveStep((prev) => prev + 1);
  }
};

const handlePrev = () => {
  if (activeStep > 0) {
    setActiveStep((prev) => prev - 1);
  }
};



        useEffect(() => {
        
          // if(courseName){}else{setSelectCoursePopUp(true);}


           if (bodyWidthForMobile.current) {
             let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
               setDeviceWidth(offsetWidth)
           }
           setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
           const observer = new IntersectionObserver(
             ([entry]) => {
               if (entry.isIntersecting) {
                 setIsVisible(true); // Set state when the div appears
               } else {
                 setIsVisible(false); // Reset state if it goes out of view
               }
             },
             {
               root: null, // Observe within the viewport
               threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
             }
           );
       
           if (bottomDivRef.current) {
             observer.observe(bottomDivRef.current);alert("jj")
           }
       
           return () => {
             if (bottomDivRef.current) {
               observer.unobserve(bottomDivRef.current);
             }
           };
         }, [deviceWidth])
     
    return <>
    
   
 <div className="gridForCreateContentOuterAll  " style={{ position:"relative",marginTop:"5px"}}   >
 
          
   
      <div className="coursePreviewAllOuterGrid" style={{ minHeight:"70vh", position:"relative"}}  >
     

     
     
      <div className=""
      // {`
      // ${!isVisible?"fixed-div-themes":"normal-div-last-themes"} 
      //  `}
        style={{ textAlign:"left",left:deviceWidth>551?mainMenuStatus?"270px":"170px":"0px",
          backgroundColor:"transparent",marginBottom:`${!isVisible?0:-divHeight}px ` ,marginTop:"0px"}} >
        <AppMenuCardBlue activeCard={activeCardBasicInfo}  icon={6} title ="Product Info" onClickPopup={
          ()=>{setActiveCardBasicInfo(true);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false);
            setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);
              history.push(`${url}/start`)
              
              }}  />
               <AppMenuCardBlue activeCard={activeCardAppearance} icon={5} title ="Set Price & Expiry" onClickPopup={()=>{
          setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false);
          setActiveCardSEO(false); setActiveCardAppearance(true);setActiveCardSettings(false);
           history.push(`${url}/price`) 
           
           }}  />
        <AppMenuCardBlue activeCard={activeCardLabels}  icon={2} title ="Labels & More" onClickPopup={
          ()=>{setActiveCardBasicInfo(false);setActiveCardLabels(true);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false);
            setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);
            history.push(`${url}/labels`)
             }}  />
        <AppMenuCardBlue activeCard={activeAdditionaInfo} icon={7} title ="Additional Info" onClickPopup={()=>{
          setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false);
          setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);
          history.push(`${url}/additional-info`)
          
          }}  />
        <AppMenuCardBlue activeCard={activeCardFreeTrial} icon={3} title ="Set Free Trial" onClickPopup={
          ()=>{setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(true);
            setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);
          history.push(`${url}/trial`)
          
          }}  />
        <AppMenuCardBlue activeCard={activeCardSEO} icon={4} title ="SEO " onClickPopup={
          ()=>{ setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false);
            setActiveCardSEO(true);setActiveCardAppearance(false);setActiveCardSettings(false);
            history.push(`${url}/seo`) 
             }}  />
       
        <AppMenuCardBlue activeCard={activeCardSettings} icon={1} title ="Settings " onClickPopup={
          ()=>{  setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false);
            setActiveCardSEO(false); setActiveCardAppearance(false);setActiveCardSettings(true);
             history.push(`${url}/settings`)
             
             }}  />
        </div>  
         </div>
         <div  className="gridRightLittleSpace"><div>
    <div className="CoursesFilterTw  " style={{zIndex:"99",marginTop:"5px"}} >
        <div className="CoursesFilterLeft" style={{zIndex:"99"}} >
{/*           
          <div  className="CoursesFilterTopTitle" >Course </div>
        <Link to={`/dashboard/create-course/course-name`}>   
         <div   className="CoursesFilterTopBtn"> Preview Course</div></Link> */}

        
{/* <div   className=" progress-bar-container "> 
   <div className="progress-bark">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`circlek ${index <= activeStep ? "activek" : ""}` }
            style={{background: `${step ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step}
          </div>
           
          </div>
        ))}
      </div>  
    
      </div> */}
      <div align="left" className="gridForTopSelectCOuseSetting" style={{borderRadius:"15px",paddingLeft:"20px"}} >
              <div align="left" className="gridForTopSelectCOuseSetting" style={{borderRadius:"15px",paddingLeft:"20px"}} ><h3 className="ButtonWithEllipsis"  >Course: {courseData?.productName}</h3> 
       
    
       {/* <Link  to={`/apps/${AppToken}/my-courses`} ><h3 style={{fontSize:"14px",color:"rgba(144, 202, 249,1)",marginTop:"20px"}}>
         Change Course</h3></Link>  */}
    <Link to={`/apps/${AppToken}/create/${TypeLink}`}> <Settings style={{padding:"20px",float:"right"}} color="#958FDA" size="20"/></Link> 
          </div>   
              
                 <h3   onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave}  onClick={()=>{setCurrentAppCourses(true)}} style={{fontSize:"14px",color:"rgba(144, 202, 249,1)",cursor:"pointer",
                marginTop:"15px",border:"2px dashed rgba(144, 202, 249,1)",padding:"10px",borderRadius:"10px",width:"40px"}}>
                   Change</h3>
                 
                    </div>
   
         </div> {courseData?<div><div className="CoursesFilterRight" style={{zIndex:"99"}} >
         <div className=""><div
          onClick={ ()=>{      
            history.push(`/preview-course/`)}}
          onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className=" CoursesPreviewTopBtn"> Preview Course</div>

     </div>
    <div className=""><div  onClick={()=>{setCurrentAppCourses(true)}} onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} className="CoursesCreateTopBtn">  Show All </div> 
 {/* <div  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CoursesCreateTopBtn">  Manage
   <div   className=" CoursesCreateTopBtnInn " style={{width:"220px"}}>  
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn" 
     style={{background:"rgba(149, 143, 218,0.8)",color:"#fff",width:"180px"}}> +Create A Batch </div>
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  className="CoursesCreateTopBtn"style={{width:"180px"}}>Add To Membership Plan </div>
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"180px",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">Add To Course Bundle </div>
       {/* <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{background:"rgba(149, 143, 218,0.8)",width:"180px",color:"#fff",border:"0px solid #fff"}}  
     className="CoursesCreateTopBtn">+Create Podcast </div> */}
      {/* </div>  */}
   {/* </div>  */}
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     
     onClick={ ()=>{      history.push(`/apps/${AppToken}/create/manage`)}}
     className="CoursesCreateTopBtn"> + Dashboard </div> 
     
 {/* <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
     
     onClick={ ()=>{    dispatch({
      type: "COURSEDATA",
      
      payload:""
    });     }}
     className="CoursesCreateTopBtn"> + New </div>  */}
   </div>
   </div>    </div>:""}
   
    </div>  
   
{currentAppCourses?<MyCourses setCurrentAppCourses={()=>{setCurrentAppCourses(false)}} />:""}

<Switch>
<Route path={`${url}/content`}><CreateCourseCurriculum selectCoursePopUp={()=>{}} setProductMenuRightCard={(productMenuRightCardPrice)=>{setProductMenuRightCardPrice(productMenuRightCardPrice)
  ;setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);}}/> </Route>

<Route path={`${url}/start`}> <ShowStartInfoCards baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
<Route path={`${url}/course-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}  producttype="course"/></Route>
<Route path={`${url}/batch-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} producttype="batch"/></Route>
<Route path={`${url}/test-series-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}producttype="testSeries"/></Route>
<Route path={`${url}/home-tutor-offering-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}producttype="homeTutor"/></Route>
<Route path={`${url}/bundle-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}producttype="bundle"/></Route>
<Route path={`${url}/digital-product-name`}> <ProductTitle baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} producttype="digitalProduct"/></Route>
    <Route path={`${url}/approx-material`}>
    <ApproxContents baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} producttype="batch"/></Route>
    <Route path={`${url}/thumbnails`}><AddThumbnailProduct  baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}  /></Route>
    <Route path={`${url}/demo-videos`}><AddDemoVideosProducts  baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(true);setActiveCardLabels(false);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>

    <Route path={`${url}/labels`}><ShowLabelsCards baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /> </Route>

    <Route path={`${url}/difficulty-level`}><DifficultyLevelLabels baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/language`}><LanguageLabels baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/type`}><TypeLabels baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/status`}><StatusLabels baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    
    <Route path={`${url}/maximum-students`}><StudentLimitProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(true);;setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/instructors`}></Route>
    <Route path={`${url}/future-start-date`}></Route>
    
    <Route path={`${url}/additional-info`}><ShowAdditionalInfoCards baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}  /> </Route>

    <Route path={`${url}/what-will-i-learn`}><WhatULearnProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}  /></Route>
    <Route path={`${url}/target-audience`}><TargetAudienceProduct  baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/prerequisite`}><PreRequisiteProduct  baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/highlights`}><HighlightsProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/skills`}><SkillsProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/faqs`}><FAQsProduct  baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(true);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /> </Route>


    <Route path={`${url}/trial`}><FreeTrial baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(true); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>

    <Route path={`${url}/seo`}><SEOProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(true);setActiveCardAppearance(false);setActiveCardSettings(false);onClickSetOverviewState();}}/></Route>

    <Route path={`${url}/appearance`}><AppearanceProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(true);onClickSetOverviewState();}} /></Route>
    
    <Route path={`${url}/settings`}><SettingsProduct baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(false);setActiveCardSettings(true);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/price`}><CreatePricePlan baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(true);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    <Route path={`${url}/expiry`}><ExpiryAndPrivacy baseUrl={url} setActiveCardOverview={(overviewStatus)=>{setActiveCardOverview(overviewStatus);setProductMenuRightCardPrice(false);setActiveCardBasicInfo(false);setActiveCardLabels(false);setActiveAdditionaInfo(false);setActiveCardFreeTrial(false); setActiveCardSEO(false);setActiveCardAppearance(true);setActiveCardSettings(false);onClickSetOverviewState();}} /></Route>
    </Switch> 
 </div>
</div>
</div>

          {selectCoursePopUp?<SelectCourseInReduxPopUp selectCoursePopUp={(selectCoursePopUp)=>{setSelectCoursePopUp(selectCoursePopUp);}} />:""}
  
    </>

}
export default CreateProduct;
